// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"95d94417","236":"223697af","327":"aef5573f","342":"50de8667","539":"88b7972f","575":"50de8667","836":"8cc5739e","980":"31afcace"}[chunkId] + ".chunk.css";
};